// extracted by mini-css-extract-plugin
export default {"heading1":"Heading1_heading1__6XOq9"};